<div class="profile">
  <img class="logo" [src]="avatar" alt="Politis logo" />
  <span>{{ userName }}</span>
</div>
<ul>
  <li>
    <button class="logout" (click)="logout()">
      <span>{{ 'Close session' | translate }}</span>
      <img src="/assets/img/icons/positive-dark/exit.svg" alt="exit icon" />
    </button>
  </li>
</ul>
